import gql from "graphql-tag"

export const CREATE_OR_UPDATE_ZAVER_CONFIG = gql`
  mutation createOrUpdateZaverConfig(
    $id: ID!
    $zaverConfig:InputZaverConfig!
  ) {
    createOrUpdateZaverConfig(
      id: $id
      zaverConfig: $zaverConfig
    ) {
      id
    }
  }
`
